<ng-template #emailChips let-emails="emails" let-onRemove="onRemove" let-onEdit="onEdit" let-onSave="onSave"
  let-chipType="chipType" let-editable="editable">
  @if (emails.length > 0) {
    <div class="email-chips">
      @for (email of emails; track trackByIndex($index)) {
        <span class="email-chip" [title]="email">
          @if (editable && editingChip?.email === email && editingChip?.type === chipType) {
            <input type="text"
              class="chip-edit-input" [value]="email" #editInput (blur)="onSave(email, editInput.value)"
              (keyup.enter)="onSave(email, editInput.value)" (keyup.escape)="cancelEditRecipient()" autofocus>
          }
          @if (!(editable && editingChip?.email === email && editingChip?.type === chipType)) {
            <span
              class="email-text" [ngClass]="{'editable': editable}"
            (dblclick)="editable && onEdit ? onEdit(email) : null">{{ email }}</span>
          }
          <i class="fas fa-times" (click)="onRemove(email)"></i>
        </span>
      }
    </div>
  }
</ng-template>

<ng-template #employeeOption let-emp>
  <div class="select-option">
    <div class="option-row">
      <div class="cell">{{ emp.name || '-' }}</div>
      <div class="cell">{{ emp.organizationLevelName || '-' }}</div>
      <div class="cell">{{ emp[employeeTypeProperty] || '-' }}</div>
      <div class="cell">{{ employeeFullNameById.get(emp.id) || '-' }}</div>
      <div class="cell">{{ emp[emailProperty] || '-' }}</div>
      <div class="cell">{{ emp[positionProperty] || '-' }}</div>
    </div>
  </div>
</ng-template>

<ng-template #employeeDropdown let-selectedId="selectedId" let-filteredList="filteredList" let-searchTerm="searchTerm"
  let-onSelectionChange="onSelectionChange" let-onSearchChange="onSearchChange" let-labelText="labelText"
  let-placeholderText="placeholderText" let-getDisplayFn="getDisplayFn" let-showClearButton="showClearButton"
  let-onClear="onClear" let-onAdvancedSearch="onAdvancedSearch" let-onScroll="onScroll"
  let-isLoadingMore="isLoadingMore">
  <div class="position-relative">
    <mat-form-field appearance="outline" class="search-extended">
      <mat-label>{{ labelText | translate }}</mat-label>
      <mat-select [ngModel]="selectedId" (selectionChange)="onSelectionChange($event.value)"
        panelClass="multiple-select-panel" (openedChange)="$event && attachScrollListener($event)">

        <mat-select-trigger>
          {{ getDisplayFn() || (placeholderText | translate) }}
        </mat-select-trigger>

        <mat-option>
          <ngx-mat-select-search [ngModel]="searchTerm" placeholderLabel="{{ 'Search' | translate }}..."
            (ngModelChange)="onSearchChange($event)">
          </ngx-mat-select-search>
        </mat-option>

        <mat-option disabled class="static-option-header">
          <div class="select-option header">
            <div class="option-row">
              <div class="cell"><strong>Id</strong></div>
              <div class="cell"><strong>{{'Organization Level' | translate}}</strong></div>
              <div class="cell"><strong>{{'Employee Type' | translate}}</strong></div>
              <div class="cell"><strong>{{'Full Name' | translate}}</strong></div>
              <div class="cell"><strong>{{'Email' | translate}}</strong></div>
              <div class="cell"><strong>{{'Position' | translate}}</strong></div>
            </div>
          </div>
        </mat-option>

        @for (emp of filteredList; track trackById($index, emp)) {
          <mat-option [value]="emp.id">
            <ng-container *ngTemplateOutlet="employeeOption; context: {$implicit: emp}"></ng-container>
          </mat-option>
        }

        @if (isLoadingMore) {
          <mat-option disabled>
            <div class="loading-more">
              <mat-spinner diameter="20"></mat-spinner>
              <span>{{'Loading more' | translate}}...</span>
            </div>
          </mat-option>
        }

        @if (!filteredList.length && !isLoadingMore) {
          <mat-option disabled>
            {{ 'No options found' | translate }}
          </mat-option>
        }
      </mat-select>

      @if (showClearButton) {
        <button mat-icon-button matSuffix tabindex="-1"
          (click)="onClear(); $event.stopPropagation()" aria-label="Clear selection">
          <mat-icon>close</mat-icon>
        </button>
      }
    </mat-form-field>

    <div class="extended-search-icon" (click)="onAdvancedSearch()" [title]="'Open advanced search' | translate">
      <span class="material-symbols-outlined">search</span>
    </div>
  </div>
</ng-template>

@if (isSending) {
  <app-rings-loader></app-rings-loader>
}

<div class="modal-header">
  <h3 class="dialog-title">
    <i class="fas fa-envelope"></i> {{ 'Send Email' | translate }}
  </h3>
  <button class="close-btn" (click)="cancel()">
    <i class="fas fa-times"></i>
  </button>
</div>

<div mat-dialog-content class="send-email-dialog-content">
  <div class="email-form-section">

    <div class="form-group compact">
      <label class="form-label">{{ 'Recipient\'s Email' | translate }}</label>
            <ng-container *ngTemplateOutlet="employeeDropdown; context: {
                selectedId: selectedEmployeeId,
                filteredList: filteredEmployees,
                searchTerm: employeeSearchTerm,
                onSelectionChange: onEmployeeSelected.bind(this),
                onSearchChange: filterEmployeesLocally.bind(this),
                labelText: 'Search Employee',
                placeholderText: 'Search Employee',
                getDisplayFn: getSelectedEmployeeDisplay.bind(this),
                showClearButton: hasSelectedEmployee,
                onClear: clearSelectedEmployee.bind(this),
                onAdvancedSearch: openEmployeeSearchDialog.bind(this, false),
                onScroll: onEmployeeDropdownScroll.bind(this),
                isLoadingMore: isLoadingMoreEmployees
            }"></ng-container>
    </div>

    <div class="form-group compact">
      <label class="form-label">CC</label>

            <ng-container *ngTemplateOutlet="employeeDropdown; context: {
                selectedId: selectedCcEmployeeId,
                filteredList: filteredCcEmployees,
                searchTerm: ccEmployeeSearchTerm,
                onSelectionChange: onCcEmployeeSelected.bind(this),
                onSearchChange: filterCcEmployeesLocally.bind(this),
                labelText: 'Search Employee for CC',
                placeholderText: 'Search Employee for CC',
                getDisplayFn: getSelectedCcEmployeeDisplay.bind(this),
                showClearButton: false,
                onClear: null,
                onAdvancedSearch: openEmployeeSearchDialog.bind(this, true),
                onScroll: onEmployeeDropdownScroll.bind(this),
                isLoadingMore: isLoadingMoreEmployees
            }"></ng-container>

      <div class="input-with-button mt-2">
        <input type="text" class="form-input" [(ngModel)]="ccRecipientInput" (keyup.enter)="addCcRecipient()"
          placeholder="{{ 'Enter email manually' | translate }}" autocomplete="off">
          <button class="add-btn" (click)="addCcRecipient()" [disabled]="!ccRecipientInput?.trim()"
            title="{{ 'Add CC recipient' | translate }}">
            <i class="fas fa-plus"></i>
          </button>
        </div>

            <ng-container *ngTemplateOutlet="emailChips; context: {
                emails: ccRecipients,
                onRemove: removeCcRecipient.bind(this),
                onEdit: editCcRecipient.bind(this),
                onSave: saveCcRecipient.bind(this),
                chipType: 'cc',
                editable: true
            }"></ng-container>
      </div>

      <div class="form-group compact">
        <div class="form-label-with-counter">
          <label class="form-label">{{ 'Subject' | translate }}</label>
          <span class="char-counter" [class.limit-reached]="emailSubject?.length >= 500">
            {{ emailSubject?.length || 0 }}/500
          </span>
        </div>
        <input type="text" class="form-input" [(ngModel)]="emailSubject"
          placeholder="{{ 'Enter Subject' | translate }}" maxlength="500">
        </div>

        <div class="form-group compact">
          <label class="form-label">{{ 'Attachments' | translate }}</label>
          @if (selectedAttachments.length > 0) {
            <div class="attachment-display">
              @for (attachment of selectedAttachments; track trackById($index, attachment)) {
                <div class="attachment-item">
                  <div class="attachment-info">
                    <i class="fas fa-paperclip attachment-icon"></i>
                    <div class="attachment-details">
                      <span class="attachment-name">{{ attachment.name }}</span>
                      @if (attachment.fileSizeInBytes) {
                        <span class="attachment-size">
                          {{ (attachment.fileSizeInBytes / 1024).toFixed(1) }} KB
                        </span>
                      }
                    </div>
                  </div>
                  <button class="remove-attachment-btn" (click)="removeAttachment(attachment)"
                    title="{{ 'Remove attachment' | translate }}">
                    <i class="fas fa-times"></i>
                  </button>
                </div>
              }
            </div>
          }
          @if (selectedAttachments.length === 0) {
            <div class="no-attachment">
              <i class="fas fa-info-circle"></i>
              <span>{{ 'No attachments selected' | translate }}</span>
            </div>
          }
        </div>

        <div class="form-group compact message-field">
          <label class="form-label">{{ 'Message' | translate }}</label>
          <app-rich-text-editor [(ngModel)]="emailMessage" [placeholder]="'Enter Message' | translate"
            minHeight="250px" maxHeight="350px">
          </app-rich-text-editor>
        </div>

        @if (emailValidationMessages.length > 0) {
          <div class="validation-messages">
            @for (message of emailValidationMessages; track trackByIndex($index)) {
              <div class="validation-error">
                <i class="fas fa-exclamation-circle"></i> {{ message | translate}}
              </div>
            }
          </div>
        }

        @if (emailWarningMessages.length > 0 && canSendEmail) {
          <div class="validation-messages">
            @for (warning of emailWarningMessages; track trackByIndex($index)) {
              <div class="validation-warning">
                <i class="fas fa-exclamation-triangle"></i> {{ warning | translate}}
              </div>
            }
          </div>
        }

      </div>
    </div>

    <div mat-dialog-actions class="dialog-actions">
      <button class="btn cancel-modal-btn" (click)="cancel()" [disabled]="isSending">
        <i class="fas fa-times"></i> {{ 'Cancel' | translate }}
      </button>
      <button class="btn save-modal-btn send-email-btn" [disabled]="!canSendEmail || isSending" (click)="sendEmail()">
        <i class="fas fa-paper-plane"></i>
        {{ isSending ? ('Sending' | translate)+'...' : ('Send' | translate) }}
      </button>
    </div>